module.exports = __webpack_public_path__ + "img/guestTab.ea97e38c.webp";